<template>
  <b-overlay
      :show="$store.getters['slsImagemHome/getIsLoading']"
      rounded="sm"
  >
    <div class="position-absolute" style="top: -50px;right: 0">
      <b-button variant="outline-primary" class="mr-2" :to="{name: 'imagens-home-list'}">Cancelar</b-button>
      <b-button
          variant="primary"
          @click="handleSubmit"
      >
        Salvar
      </b-button>
    </div>
    <validation-observer ref="refFormCreateImagemHome">
      <b-form>
        <b-row>
          <b-col cols="12">
            <b-card>
              <b-card-title class="bg-gray">
                <span>Configurar Imagem</span>
              </b-card-title>
              <b-row>
                <b-col cols="12" sm="4">
                  <b-form-group label="Marca">
                    <validation-provider
                        #default="{ errors }"
                        name="Marca"
                        rules="required"
                    >
                      <b-form-select
                          v-model="formCreateImagemHome.cod_marca"
                          label-field="text"
                          :state="errors.length > 0 ? false:null"
                          value-field="value"
                          :options="$store.getters['slsImagemHome/getOptionsMarcas']"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                  <b-form-group label="Imagem">
                    <validation-provider
                        #default="{ errors }"
                        name="Imagem"
                        rules="required"
                    >
                <b-form-file
                    v-model="formCreateImagemHome.caminho"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Escolha um arquivo ou arraste-o aqui..."
                    drop-placeholder="Solte o arquivo aqui..."
                    accept="image/*"
                    @change="changeImg($event, 'caminho')"
                    @drop="changeImg($event, 'caminho')"
                ></b-form-file>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="8" class="d-flex justify-content-center">
                  <b-form-group>
                    <div class="molde-img">
                      <b-img
                          v-if="imagemPresenter.caminho !== ''"
                          :src="imagemPresenter.caminho"
                          fluid alt="Responsive image"
                          width="261"
                          height="350"
                          style="max-width: 350px; max-height: 261px;min-width: 350px; min-height: 261px;"
                      />
                      <div class="box-img-empty" v-else>
                        <b-img icon="image" font-scale="2" class="text-white"></b-img>
                      </div>
                    </div>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="4">
                  <b-form-group label="Catálogo">
                    <validation-provider
                        #default="{ errors }"
                        name="Catagolo PDF"
                        rules="required"
                    >
                      <b-form-file
                          v-model="formCreateImagemHome.caminho_catalogo"
                          :state="errors.length > 0 ? false:null"
                          placeholder="Escolha um arquivo ou arraste-o aqui..."
                          drop-placeholder="Solte o arquivo aqui..."
                          accept=".pdf"
                      ></b-form-file>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="12">

                  <b-form-group label="Ordem Apresentação na Home">
                    <validation-provider
                        #default="{ errors }"
                        name="Ordem Apresentação"
                        rules="required"
                    >
                      <b-row>

                        <b-col cols="12" sm="2">

                          <b-form-input
                              v-model="formCreateImagemHome.ordem_visualizacao"
                              :state="errors.length > 0 ? false:null"
                              type="number"
                              placeholder="Ex. 2"
                          />

                        </b-col>
                      </b-row>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                </b-col>

              </b-row>
            </b-card>
          </b-col>

          <b-col cols="12">
            <b-card>
              <b-card-title class="bg-gray">
                <span>Cadastro Imagem Cabeçalho Tela Marcas</span>
              </b-card-title>
              <b-row>
                <b-col cols="12" sm="8">
                  <b-form-group label="Cor cabeçalho página marcas">

                    <b-row class="mb-3">
                      <b-col cols="12" sm="4">
                        <b-form-input
                            type="color"
                            v-model="formCreateImagemHome.cor_cabecalho_marca"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" sm="6">
                        <b-form-group label="Imagem do Cabeçalho Marcas">
                          <validation-provider
                              #default="{ errors }"
                              name="Imagem do Cabeçalho Marcas"
                              rules="required"
                          >
                            <b-form-file
                                v-model="formCreateImagemHome.caminho_img_cabec_marcas"
                                :state="errors.length > 0 ? false:null"
                                placeholder="Escolha um arquivo ou arraste-o aqui..."
                                drop-placeholder="Solte o arquivo aqui..."
                                accept="image/*"
                                @change="changeImg($event, 'caminho_img_cabec_marcas')"
                                @drop="changeImg($event, 'caminho_img_cabec_marcas')"
                            ></b-form-file>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="4">
                  <b-col cols="12" sm="8" class="d-flex justify-content-center">
                    <b-form-group>

                      <div>
                        <b-img
                            v-if="imagemPresenter.caminho_img_cabec_marcas !== ''"
                            :src="imagemPresenter.caminho_img_cabec_marcas"
                            fluid
                            alt="Imagem do Cabeçalho Marcas"
                            :style="{ 'background-color': formCreateImagemHome.cor_cabecalho_marca }"
                            width="250"
                            height="100"
                            style="max-width: 250px; max-height: 100px;min-width: 250px; min-height: 100px;"
                        />
                        <div class="box-img-empty-primary-secondary" v-else
                             :style="{ 'background-color': formCreateImagemHome.cor_cabecalho_marca }">
                          <b-img
                              icon="image"
                              font-scale="2"

                              class="text-white"
                          ></b-img>
                        </div>
                      </div>

                    </b-form-group>
                  </b-col>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col cols="12">
            <b-card>
              <b-card-title class="bg-gray">
                <span>Cadastro Imagem rodapé</span>
              </b-card-title>
              <b-row class="mb-5">
                <b-col cols="12" sm="4">
                  <b-form-group label="Imagem do rodapé principal">
                    <validation-provider
                        #default="{ errors }"
                        name="Caminho Imagem Rodapé Principal"
                        rules="required"
                    >
                      <b-form-file
                          v-model="formCreateImagemHome.caminho_img_footer_principal"
                          :state="errors.length > 0 ? false:null"
                          placeholder="Escolha um arquivo ou arraste-o aqui..."
                          drop-placeholder="Solte o arquivo aqui..."
                          accept="image/*"
                          @change="changeImg($event, 'caminho_img_footer_principal')"
                          @drop="changeImg($event, 'caminho_img_footer_principal')"
                      ></b-form-file>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="8" class="d-flex justify-content-center">
                  <b-form-group>
                    <div>
                      <b-img
                          v-if="imagemPresenter.caminho_img_footer_principal !== ''"
                          :src="imagemPresenter.caminho_img_footer_principal"
                          fluid
                          alt="Roda pé principal"
                          width="250"
                          height="100"
                          style="max-width: 250px; max-height: 100px;"
                      />
                      <div class="box-img-empty-primary-secondary" v-else>
                        <b-img icon="image" font-scale="2" class="text-white"></b-img>
                      </div>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" sm="4">
                  <b-form-group label="Imagem do rodapé secundária">
                    <validation-provider
                        #default="{ errors }"
                        name="Caminho Imagem Rodapé Secundária"
                        rules="required"
                    >
                      <b-form-file
                          v-model="formCreateImagemHome.caminho_img_footer_secundaria"
                          :state="errors.length > 0 ? false:null"
                          placeholder="Escolha um arquivo ou arraste-o aqui..."
                          drop-placeholder="Solte o arquivo aqui..."
                          accept="image/*"
                          @change="changeImg($event, 'caminho_img_footer_secundaria')"
                          @drop="changeImg($event, 'caminho_img_footer_secundaria')"
                      ></b-form-file>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="8" class="d-flex justify-content-center">
                  <b-form-group>
                    <div>
                      <b-img
                          v-if="imagemPresenter.caminho_img_footer_secundaria !== ''"
                          :src="imagemPresenter.caminho_img_footer_secundaria"
                          fluid
                          alt="Roda pé secundário"
                          width="250"
                          height="100"
                          style="max-width: 250px; max-height: 100px;"
                      />
                      <div class="box-img-empty-primary-secondary" v-else>
                        <b-img icon="image" font-scale="2" class="text-white"></b-img>
                      </div>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-overlay>
</template>

<script>
import {
  required, email, confirmed, url, between, alpha, integer, password, min, digits, alphaDash, length,
} from '@validations';
import HbiImagemHomeService from '@/services/SistemaDKP/sls-imagem-home.service';

const imagemHomeService = new HbiImagemHomeService();
export default {
  name: 'EditIndex',
  data() {
    return {
      required,
      email,
      confirmed,
      url,
      between,
      alpha,
      integer,
      password,
      min,
      digits,
      alphaDash,
      length,
      imagemHomeService,
      formCreateImagemHome: {
        log_img_id: null,
        cod_marca: null,
        caminho: null,
        caminho_catalogo: null,
        ordem_visualizacao: null,
        cor_cabecalho_marca: '#000000', // '#fff
        caminho_img_cabec_marcas: null,
        caminho_img_footer_principal: null,
        caminho_img_footer_secundaria: null,
      },
      imagemPresenter: {
        caminho: '',
        caminho_img_cabec_marcas: '',
        caminho_img_footer_principal: '',
        caminho_img_footer_secundaria: '',
      },
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.refFormCreateImagemHome.validate().then(async (valid) => {
        if (valid) {
          await this.imagemHomeService.save(this.formCreateImagemHome);
          await this.$refs.refFormCreateImagemHome.reset();
          await this.$router.push({ name: 'imagens-home-list' });
        }
      });
    },
    changeImg(event, nameVar) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imagemPresenter[nameVar] = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
  },
  async mounted() {
    await imagemHomeService.findAllMarcars();
    await this.$refs.refFormCreateImagemHome.reset();
  },
};
</script>

<style scoped lang="scss">
.molde-img {
  border: 2px solid #ccc;
  display: flex;
  justify-content: center;

  img {
    padding: 10px;
    height: 100%;
    width: 100%;
  }
}

.box-img-empty {
  border: 2px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  width: 400px;

  img {
    padding: 10px;
    max-height: 300px;
  }
}

.box-img-empty-primary-secondary {
  border: 2px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  width: 250px;

  img {
    padding: 10px;
    max-height: 100px;
    max-width: 250px;
  }
}

</style>
